/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SystemService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Sends a test mail.
     * @param eMailAddress The e mail address.
     * @returns any Success
     * @throws ApiError
     */
    public systemSendTestMail(
        eMailAddress?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1.0/system/mail/sendtest',
            query: {
                'eMailAddress': eMailAddress,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

}
